module.exports = __webpack_public_path__ + "static/assets/5c453b36874c539675eda1150f0e23e3.svg";